import type React from 'react';

/** @deprecated Use icons from icons-v2-generated instead. */
export interface LaptopIconProps extends React.SVGProps<SVGSVGElement> {
  color?: string;
}

/** @deprecated Use icons from icons-v2-generated instead. */
export function LaptopIcon({ className, color = 'white', ...props }: LaptopIconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M19.875 17.0005V7C19.875 5.96447 19.0355 5.125 18 5.125H6C4.96447 5.125 4.125 5.96447 4.125 7V17.0005C4.12474 17.6216 3.62116 18.1255 3 18.1255C2.37884 18.1255 1.87526 17.6216 1.875 17.0005V7C1.875 4.72183 3.72183 2.875 6 2.875H18C20.2782 2.875 22.125 4.72183 22.125 7V17.0005C22.1247 17.6216 21.6212 18.1255 21 18.1255C20.3788 18.1255 19.8753 17.6216 19.875 17.0005Z"
        fill={color}
      />
      <path
        d="M3.13232 18.125C3.19675 19.1022 4.00654 19.8755 5 19.8755H18.9995C19.993 19.8755 20.8043 19.1022 20.8687 18.125H15.4663L15.0884 18.5029C14.6899 18.9013 14.149 19.1255 13.5854 19.1255H10.4141C9.92104 19.1255 9.44594 18.9533 9.06787 18.6436L8.91113 18.5029L8.53467 18.125H3.13232ZM23.1245 18.0005C23.1242 20.2784 21.2775 22.1255 18.9995 22.1255H5C2.72199 22.1255 0.875264 20.2784 0.875 18.0005C0.875 16.8269 1.82688 15.875 3.00049 15.875H8.58594C9.07907 15.875 9.55401 16.0471 9.93213 16.3569L10.0889 16.4976L10.4653 16.8755H13.5342L13.9121 16.4976L14.0674 16.3569C14.4454 16.047 14.9205 15.8752 15.4136 15.875H21.0005C22.1739 15.8753 23.1245 16.8271 23.1245 18.0005Z"
        fill={color}
      />
    </svg>
  );
}
